import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Stack, Button } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import {
  AvcUrl,
  VoiceDomainName,
  VoiceDomainNamePure,
  AvcUrlagmc,
  VoiceDomainNameagmc,
  PowerBiurl,
  PortalUrl,
} from "../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import {
  setDialedNumberInc,
  setshowphonedialer,
} from "../../Redux/Actions/actions.js";
import { toaststyle } from "../../Utils/toaststyle.js";
import { RiShieldUserFill } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { MdCall } from "react-icons/md";
import { IoMdBackspace } from "react-icons/io";
import { MdRefresh } from "react-icons/md";

const mapStateToProps = (state) => {
  return {
    showphonedialer: state.voice.showphonedialer,
    cli: state.voice.cli,
    voicePlatForm: state.voice.voicePlatForm,
    webRTC: state.voice.webRTC,
  };
};

const Dialer = (props) => {
  const {
    showphonedialer,
    dailedNumber,
    setDialedNumber,
    voicePlatForm,
    aesSocket,
  } = props;
  const permissionStr = localStorage.getItem("permission");
  const [MakeCallDaileDisable, setMakeCallDaileDisable] = useState(false);
  const makeCall = async () => {
    let AvcUrl = localStorage.getItem("AvcUrl");
    let agentdetails = JSON.parse(localStorage.getItem("tokenAgent"));
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    if (voicePlatForm == "AACC" || voicePlatForm == "ACCS") {
      if (agentLoginTerminalId == dailedNumber) return;
      if (dailedNumber == "") return alert("Please enter a valid Number");
      props.setDialedNumberInc(dailedNumber);
      localStorage.setItem("redialedNumber", dailedNumber);
      localStorage.setItem("dailedNumber", dailedNumber);
      localStorage.setItem("ClickToCall", "false");

      let dailedNumber2 = null;
      if (dailedNumber.includes("+")) {
        dailedNumber2 = dailedNumber.replace("+", "00");
      } else {
        dailedNumber2 = dailedNumber;
      }

      const voiceUrl =
        localStorage.getItem("TenantId") ==
        "788205e1-6116-4c09-904a-5b641d09de0f"
          ? AvcUrl
          : localStorage.getItem("TenantId") ==
              "afb31819-2128-4d23-9bae-2ff09c53246f"
            ? AvcUrlagmc
            : AvcUrl;
      axios
        .post(
          voiceUrl +
            `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${
              localStorage.getItem("TenantId") ==
              "788205e1-6116-4c09-904a-5b641d09de0f"
                ? VoiceDomainNamePure
                : localStorage.getItem("TenantId") ==
                    "afb31819-2128-4d23-9bae-2ff09c53246f"
                  ? VoiceDomainNameagmc
                  : VoiceDomainName
            }/sip:${agentdetails && agentdetails.group_array && agentdetails.group_array[0] == "32825f9c-cd9a-4aea-8995-64aa9205d16c" ? dailedNumber2 : dailedNumber2}@${
              localStorage.getItem("TenantId") ==
              "788205e1-6116-4c09-904a-5b641d09de0f"
                ? VoiceDomainNamePure
                : localStorage.getItem("TenantId") ==
                    "afb31819-2128-4d23-9bae-2ff09c53246f"
                  ? VoiceDomainNameagmc
                  : VoiceDomainName
            }`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          },
        )
        .then(async (res) => {
          if (res.data.status == "OK") {
            const permission = permissionStr ? JSON.parse(permissionStr) : [];
            const voiceModule = permission.find(
              (module) => module.moduleName === "VOICE_INTERACTION",
            );
            const outboundCrm = voiceModule?.screen?.find(
              (item) =>
                item.screenId === "OUTBOUNDCRM" && item.read && item.write,
            );

            if (outboundCrm) {
              const res = await axios.post(
                `${PortalUrl}/v1/purple/screenpopup`,
                {
                  agentextn: agentdetails?.voiceRecord?.avayaUserName,
                  callerno: agentLoginTerminalId,
                  phonenumber: dailedNumber2,
                },
                {
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                    tenantid: localStorage.getItem("TenantId"),
                  },
                },
              );
              if (res.data && res.data.data) {
                window.open(res.data.data, "_blank");
              } else {
                console.warn("No URL returned from CRM API", res.data);
              }
            }

            setDialedNumber("");
            localStorage.setItem("DCC_CALL", "true");
          } else {
            toast.warn("Call Can't be Made", toaststyle);
          }
        })
        .catch((err) => {});
    } else if (voicePlatForm == "ACR") {
    } else if (voicePlatForm == "AES") {
      const extensionNum = JSON.parse(localStorage.getItem("AvayaUsername"));
      if (extensionNum == dailedNumber) {
        return alert("Don't Enter Same Extension Number You LoggedIn With");
      } else if (dailedNumber == "") {
        return alert("Please enter a valid Number");
      }
      props.setDialedNumberInc(dailedNumber);
      localStorage.setItem("redialedNumber", dailedNumber);
      localStorage.setItem("dailedNumber", dailedNumber);
      const RegDetails = {
        Event: "MakeCall",
        Extension: dailedNumber,
      };
      aesSocket.send(JSON.stringify(RegDetails));
    }
  };

  const makeCallValidation = () => {
    if (!dailedNumber) return;
    setMakeCallDaileDisable(true);
    axios
      .post(
        PowerBiurl + `v1/purple/makecallvalidation`,
        {
          phonenumber: dailedNumber,
        },
        {
          headers: {
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if (res.data.status) {
          makeCall();
        } else {
          toast.error("Customer Number Is Blocked", toaststyle);
          setMakeCallDaileDisable(false);
        }
      })
      .catch((err) => {
        setMakeCallDaileDisable(false);
        toast.error("Customer Number Is Blocked", toaststyle);
      });
  };
  const getTerminalId = () => {
    if (voicePlatForm == "ACR") {
      return JSON.parse(
        localStorage.getItem("tokenAgent"),
      ).voiceRecord.avayaUserName.slice(4, 10);
    } else if (voicePlatForm == "AES") {
      return JSON.parse(localStorage.getItem("tokenAgent")).voiceRecord
        .avayaUserName;
    } else {
      return localStorage.getItem("agentLoginTerminalId");
    }
  };

  return (
    <motion.div
      drag
      dragConstraints={props.referance}
      className="keypad-main"
      style={{
        display: showphonedialer ? "block" : "block",
      }}
    >
      <Grid container alignItems="center">
        <Grid item xs={10}>
          <Grid>
            {/* Extension number  */}
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={0}
            >
              <Stack
                className="Btn-Container p-1"
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={0}
              >
                <Stack>
                  <span className="icon-Container me-2">
                    <RiShieldUserFill size={9} />
                  </span>
                </Stack>
                <Stack
                  className="text-Container me-2"
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={0}
                  sx={{ minWidth: 0 }}
                >
                  <span className="text fs-11 fw-bold">{getTerminalId()}</span>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
        <Grid item xs={2}>
          {/* close btn  */}
          <Box>
            <IconButton
              aria-label="delete"
              size="small"
              color="error"
              onClick={() => {
                props.setshowphonedialer(false);
              }}
            >
              <IoClose />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      {/* <!-- ## phone area --> */}
      <Box className="phone">
        {/* <!-- ## phone area --> */}
        <Box className="phone-container">
          <input
            type="text"
            maxLength="15"
            className="number-input"
            value={dailedNumber}
            autoFocus
            onChange={(e) => {
              let value = e.target.value;
              if (value.startsWith("+")) {
                value = "+" + value.slice(1).replace(/[^\d]/g, "");
              } else {
                value = value.replace(/[^\d]/g, "");
              }
              setDialedNumber(value);
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                makeCallValidation();
                return;
              }
              const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
              ];
              if (
                (event.ctrlKey || event.metaKey) &&
                ["v", "c", "x", "a"].includes(event.key.toLowerCase())
              )
                return;
              if (allowedKeys.includes(event.key)) return;

              const isFirstChar = dailedNumber.length === 0;
              const isPlus = event.key === "+";

              if (isPlus && isFirstChar) return;
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
          {/* <!-- ## keyboard --> */}
          <div className="keyboard">
            <div className="number row row-cols-3">
              <div data-number="1">
                <div
                  className="number-sub"
                  id="one"
                  value="1"
                  onClick={() =>
                    setDialedNumber((dailedNumber) => `${dailedNumber}1`)
                  }
                >
                  1
                </div>
              </div>
              <div data-number="2">
                <div
                  className="number-sub"
                  id="two"
                  value="2"
                  onClick={() =>
                    setDialedNumber((dailedNumber) => `${dailedNumber}2`)
                  }
                >
                  2
                </div>
              </div>
              <div data-number="3">
                <div
                  className="number-sub"
                  id="three"
                  value="3"
                  onClick={() =>
                    setDialedNumber((dailedNumber) => `${dailedNumber}3`)
                  }
                >
                  3
                </div>
              </div>
              <div
                data-number="4"
                id="four"
                value="4"
                onClick={() =>
                  setDialedNumber((dailedNumber) => `${dailedNumber}4`)
                }
              >
                <div className="number-sub">4</div>
              </div>
              <div
                data-number="5"
                id="five"
                value="5"
                onClick={() =>
                  setDialedNumber((dailedNumber) => `${dailedNumber}5`)
                }
              >
                <div className="number-sub">5</div>
              </div>
              <div
                data-number="6"
                id="six"
                value="6"
                onClick={() =>
                  setDialedNumber((dailedNumber) => `${dailedNumber}6`)
                }
              >
                <div className="number-sub">6</div>
              </div>
              <div
                data-number="7"
                id="seven"
                value="7"
                onClick={() =>
                  setDialedNumber((dailedNumber) => `${dailedNumber}7`)
                }
              >
                <div className="number-sub">7</div>
              </div>
              <div data-number="8">
                <div
                  className="number-sub"
                  id="eight"
                  value="8"
                  onClick={() =>
                    setDialedNumber((dailedNumber) => `${dailedNumber}8`)
                  }
                >
                  8
                </div>
              </div>
              <div
                data-number="9"
                id="nine"
                value="9"
                onClick={() =>
                  setDialedNumber((dailedNumber) => `${dailedNumber}9`)
                }
              >
                <div className="number-sub">9</div>
              </div>
              <div data-number="7">
                <div
                  className="number-sub"
                  id="*"
                  value="astrick"
                  onClick={() =>
                    setDialedNumber((dailedNumber) => `${dailedNumber}*`)
                  }
                >
                  *
                </div>
              </div>
              <div data-number="8">
                <div
                  className="number-sub"
                  id="zero"
                  value="0"
                  onClick={() =>
                    setDialedNumber((dailedNumber) => `${dailedNumber}0`)
                  }
                >
                  0
                </div>
              </div>
              <div data-number="9">
                <div
                  className="number-sub"
                  id="hash"
                  value="#"
                  onClick={() =>
                    setDialedNumber((dailedNumber) => `${dailedNumber}#`)
                  }
                >
                  #
                </div>
              </div>
            </div>
            {/* <!-- ## keypad btn -->  */}
            <div className="keypadbtn row row-cols-3 mt-3">
              <div className="col">
                <button
                  type="button"
                  className="delete"
                  id="redial"
                  onClick={() => {
                    setDialedNumber(
                      localStorage.getItem("redialedNumber")
                        ? localStorage.getItem("redialedNumber")
                        : "",
                    );
                  }}
                >
                  <MdRefresh />
                </button>
              </div>
              <div className="col">
                <button
                  type="button"
                  disabled={MakeCallDaileDisable}
                  className="btn btn-success call-button"
                  id="make-call-from-dialer"
                  onClick={() => {
                    makeCallValidation();
                  }}
                >
                  <MdCall />
                </button>
              </div>
              <div className="col">
                <button
                  type="button"
                  className="delete"
                  id="clear-dialer-number"
                  onClick={() =>
                    setDialedNumber((dailedNumber) =>
                      dailedNumber.slice(0, dailedNumber.length - 1),
                    )
                  }
                >
                  <IoMdBackspace />
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Box>
    </motion.div>
  );
};

export default connect(mapStateToProps, {
  setDialedNumberInc,
  setshowphonedialer,
})(Dialer);
